import React, { PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { useOffreService } from '@europrocurement/l2d-domain';
import DossierArticleContext, { ArticleCategory } from './DossierArticleContext';
import { useDomaine } from '../../ParcoursFormalite/hooks/index';

const DossierArticleProvider: React.FunctionComponent<PropsWithChildren> = function ({ children }) {
    const [articleCategories, setArticleCategories] = useState<Array<ArticleCategory>>([]);
    const { articlesCategoriesApi } = useOffreService();
    const domaine = useDomaine();

    const loadArticlesCategories = async () => {
        try {
            const response = await articlesCategoriesApi.apiCategoriesArticlesGetCollection({
                domaineId: domaine,
                itemsPerPage: 999,
            });
            const items = response.data['hydra:member'] || [];

            setArticleCategories(
                items.map((item) => ({
                    id: item.id as number,
                    label: item.libelle as string,
                    validatorTypeId: item.validatorType?.id
                        ? (item.validatorType?.id as number)
                        : 0,
                })),
            );
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        loadArticlesCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const contextValue = useMemo(
        () => ({
            articleCategories,
        }),
        [articleCategories],
    );

    return (
        <DossierArticleContext.Provider value={contextValue}>
            {children}
        </DossierArticleContext.Provider>
    );
};

export default DossierArticleProvider;
